import { Typography } from "@/components/kit";
import SvgIcon from "@/components/common/SvgIcon";

const NoResult = () => {
  return (
    <div className="flex flex-col items-center gap-1 flex-1 justify-center">
      <div className="flex flex-col justify-center items-center  gap-4">
        <div className="w-[150px] h-[120px]">
          <SvgIcon
            iconName="emptySearchState"
            className="w-[150px] h-[120px]"
            fill="fill-unset"
          />
        </div>
        <Typography variant="Title2-Bold" color="text-gray-700">
          No results
        </Typography>
      </div>
      <Typography variant="Title5-Regular" className="!text-gray-400">
        The content you searched for is not found{" "}
      </Typography>
    </div>
  );
};

export default NoResult;
